import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import { EMPTY_ARRAY, NOTICE_ICON_MAP } from './formatters.js'
import styles from './common.module.css'

interface NoticesBlockProps extends BlockProps {
  layout?: 'list'
}

export function NoticesBlock({ invitation, activeSection, onSectionClick, mode }: NoticesBlockProps) {
  const notices = invitation.notices ?? EMPTY_ARRAY

  return (
    <SectionWrapper
      sectionId="notices"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <span className={styles.sectionTitle}>안내사항</span>
      <div className={styles.divider} />
      {notices.length > 0
        ? notices.map((item, i) => {
            const IconComp = item.icon ? NOTICE_ICON_MAP[item.icon] : undefined
            return (
              <div key={i} className={styles.noticeItem}>
                {IconComp && <IconComp size={12} className={styles.noticeIcon} />}
                <div>
                  <p className={styles.listItemTitle}>{item.title}</p>
                  {item.description && <p className={styles.listItemDesc}>{item.description}</p>}
                </div>
              </div>
            )
          })
        : <p className={styles.placeholderText}>안내사항이 여기에 표시됩니다</p>
      }
    </SectionWrapper>
  )
}
